<template>
  <transition :key="`toast1-${+new Date()}`" name="toast-fade">
    <div v-show="visible" :key="`toast-${+new Date()}`" class="toast" @click="visible = false">
      {{ text }}
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      text: '',
      visible: false,
      duration: 2000,
    }
  },
}
</script>
<style lang="scss" scoped>
.toast {
  z-index: 9000;
  height: 45px;
  padding: 0 22px;
  background: rgba(53,69,96,1);
  border-radius: 22px;
  line-height: 45px;
  text-align: center;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  color:rgba(221,221,221,1);
  white-space: nowrap;
}
@media screen and (max-width: 1080px){
  .toast{
    font-size:2.5rem;
    padding:2rem  ;
    border-radius: 4rem;
  }
}
</style>

<style>
.toast-fade-enter {
  opacity: 0.5;
  transform: translate(50px);
}
.toast-fade-enter-active {
  will-change: transform;
  transition: all 0.6s;
}
.toast-fade-enter-to {
  opacity: 1;
  transform: translate(-50%, -50%);
}
.toast-fade-leave {
  opacity: 0;
}
.toast-fade-leave-active {
  will-change: transform;
  transition: all 0.6s;
}
.toast-fade-leave-to {
  opacity: 0;
}
</style>
